/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AiMessageRoleType: { input: import('../../shared/types.ts').AiMessageRoleType; output: import('../../shared/types.ts').AiMessageRoleType; }
  AiMessageType: { input: import('../../shared/types.ts').AiMessageType; output: import('../../shared/types.ts').AiMessageType; }
  AiThreadRatingType: { input: import('../../shared/types.ts').AiThreadRatingType; output: import('../../shared/types.ts').AiThreadRatingType; }
  AnswerType: { input: import('../../shared/types.ts').AnswerType; output: import('../../shared/types.ts').AnswerType; }
  AppRatingType: { input: import('../../shared/types.ts').AppRatingType; output: import('../../shared/types.ts').AppRatingType; }
  CollectFeedbackQuestionType: { input: import('../../shared/types.ts').CollectFeedbackQuestionType; output: import('../../shared/types.ts').CollectFeedbackQuestionType; }
  ContentFormat: { input: import('../../shared/types.ts').ContentFormat; output: import('../../shared/types.ts').ContentFormat; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DoInGroupType: { input: import('../../shared/types.ts').DoInGroupType; output: import('../../shared/types.ts').DoInGroupType; }
  Gender: { input: import('../../shared/types.ts').Gender; output: import('../../shared/types.ts').Gender; }
  ImageSelectionAnswerType: { input: import('../../shared/types.ts').ImageSelectionAnswerType; output: import('../../shared/types.ts').ImageSelectionAnswerType; }
  ItemLockedType: { input: any; output: any; }
  Language: { input: import('../../shared/types.ts').Language; output: import('../../shared/types.ts').Language; }
  LeaderboardModeType: { input: import('../../shared/types.ts').LeaderboardModeType; output: import('../../shared/types.ts').LeaderboardModeType; }
  LearningPathItemType: { input: import('../../shared/types.ts').LearningPathItemType; output: import('../../shared/types.ts').LearningPathItemType; }
  MediaType: { input: any; output: any; }
  NotificationSendLimitType: { input: import('../../shared/types.ts').NotificationSendLimitType; output: import('../../shared/types.ts').NotificationSendLimitType; }
  NotificationType: { input: import('../../shared/types.ts').NotificationType; output: import('../../shared/types.ts').NotificationType; }
  PathGroupAssignType: { input: import('../../shared/types.ts').PathGroupAssignType; output: import('../../shared/types.ts').PathGroupAssignType; }
  PathStatus: { input: import('../../shared/types.ts').PathStatus; output: import('../../shared/types.ts').PathStatus; }
  PlayerStatus: { input: import('../../shared/types.ts').PlayerStatus; output: import('../../shared/types.ts').PlayerStatus; }
  PollChartType: { input: import('../../shared/types.ts').PollChartType; output: import('../../shared/types.ts').PollChartType; }
  PublishStatus: { input: import('../../shared/types.ts').PublishStatus; output: import('../../shared/types.ts').PublishStatus; }
  RoleName: { input: import('../../shared/types.ts').Role; output: import('../../shared/types.ts').Role; }
  ShareAnswersType: { input: import('../../shared/types.ts').ShareAnswersType; output: import('../../shared/types.ts').ShareAnswersType; }
  SubmittedFeedbackTaskStatus: { input: import('../../shared/types.ts').SubmittedFeedbackTaskStatus; output: import('../../shared/types.ts').SubmittedFeedbackTaskStatus; }
  SubmittedTaskStatus: { input: import('../../shared/types.ts').SubmittedTaskStatus; output: import('../../shared/types.ts').SubmittedTaskStatus; }
  SuggestedQuestionsType: { input: import('../../shared/types.ts').SuggestedQuestionsType; output: import('../../shared/types.ts').SuggestedQuestionsType; }
  TaskIcon: { input: import('../../shared/types.ts').TaskIcon; output: import('../../shared/types.ts').TaskIcon; }
  TaskLockedType: { input: import('../../shared/types.ts').TaskLockedType; output: import('../../shared/types.ts').TaskLockedType; }
  TaskThemeType: { input: import('../../shared/types.ts').TaskThemeType; output: import('../../shared/types.ts').TaskThemeType; }
  TaskThreadItemSubtype: { input: any; output: any; }
  TaskThreadItemType: { input: import('../../shared/types.ts').TaskThreadItemType; output: import('../../shared/types.ts').TaskThreadItemType; }
  TaskType: { input: import('../../shared/types.ts').TaskType; output: import('../../shared/types.ts').TaskType; }
  TeamScanStatus: { input: import('../../shared/types.ts').TeamScanStatus; output: import('../../shared/types.ts').TeamScanStatus; }
  TimeEstimateType: { input: import('../../shared/types.ts').TimeEstimateType; output: import('../../shared/types.ts').TimeEstimateType; }
  VariantType: { input: import('../../shared/types.ts').VariantType; output: import('../../shared/types.ts').VariantType; }
};

export type AccountInvitation = {
  createdDatetime: Scalars['DateTime']['output'];
  creator: Maybe<Person>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  learningPath: Maybe<LearningPath>;
  link: Scalars['String']['output'];
  locale: Scalars['Language']['output'];
  organisation: Organisation;
  pathGroup: Maybe<PathGroup>;
  pathGroupAssignType: Scalars['PathGroupAssignType']['output'];
  person: Maybe<Person>;
  publicId: Scalars['String']['output'];
  role: Role;
  standaloneAiChatbot: Maybe<StandaloneAiChatbot>;
  taskGroups: Array<TaskGroup>;
  team: Maybe<Team>;
  teamScan: Scalars['Boolean']['output'];
  teamScanSizeLimit: Maybe<Scalars['Int']['output']>;
  usedDatetime: Maybe<Scalars['DateTime']['output']>;
};

export type AccountInvitationAssociateAccount = {
  error: Maybe<Scalars['String']['output']>;
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type AccountInvitationCreateAccount = {
  error: Maybe<Scalars['String']['output']>;
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type AdminCompletions = {
  completions: Array<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  ids: Array<Scalars['Int']['output']>;
  names: Array<Scalars['String']['output']>;
  taskIds: Array<Array<Maybe<Scalars['Int']['output']>>>;
  tasks: Array<Scalars['String']['output']>;
};

export type AdminTeamScanReport = {
  membersWhoAnswered: Scalars['Int']['output'];
  sna: Maybe<AdminTeamScanReportSnaData>;
  tlb: Maybe<AdminTeamScanReportVariable>;
  tps: Maybe<AdminTeamScanReportVariable>;
};

export type AdminTeamScanReportSnaData = {
  centralisation: Scalars['Float']['output'];
  density: Scalars['Float']['output'];
  links: Array<AdminTeamScanReportSnaLink>;
  nodes: Array<AdminTeamScanReportSnaNode>;
  teamLeaderLeadership: Scalars['Float']['output'];
  teamMemberAverageLeadership: Scalars['Float']['output'];
};

export type AdminTeamScanReportSnaLink = {
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type AdminTeamScanReportSnaNode = {
  id: Scalars['String']['output'];
  incoming: Scalars['Float']['output'];
  teamLeader: Scalars['Boolean']['output'];
};

export type AdminTeamScanReportVariable = {
  actionPoints: Array<Scalars['String']['output']>;
  mean: Scalars['Float']['output'];
  membersMeans: Array<Scalars['Float']['output']>;
  questionIds: Array<Scalars['String']['output']>;
  questionMeans: Array<Scalars['Float']['output']>;
  questionStds: Array<Scalars['Float']['output']>;
  std: Scalars['Float']['output'];
  strengths: Array<Scalars['String']['output']>;
  weaknesses: Array<Scalars['String']['output']>;
};

export type AiNewsletter = {
  aiThreadItems: Maybe<Array<Maybe<AiThreadItem>>>;
  content: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  learningPath: LearningPath;
  personality: Scalars['String']['output'];
  previousNewsletter: Maybe<AiNewsletter>;
  recipients: Array<Maybe<Scalars['String']['output']>>;
  startDate: Scalars['String']['output'];
  subject: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type AiThreadContextData = {
  avgRelevance: Maybe<Scalars['Float']['output']>;
  documentName: Maybe<Scalars['String']['output']>;
  documentNames: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hydePassage: Maybe<Scalars['String']['output']>;
  keywordQuery: Maybe<Scalars['String']['output']>;
  semanticQuery: Maybe<Scalars['String']['output']>;
};

export type AiThreadItem = {
  content: Scalars['String']['output'];
  contextData: Maybe<AiThreadContextData>;
  encryptedReasoning: Maybe<Scalars['String']['output']>;
  hide: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
  rating: Maybe<Scalars['AiThreadRatingType']['output']>;
  reasoningId: Maybe<Scalars['String']['output']>;
  reasoningSummary: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role: Maybe<Scalars['AiMessageRoleType']['output']>;
  toolArguments: Maybe<Scalars['String']['output']>;
  toolCallId: Maybe<Scalars['String']['output']>;
  toolName: Maybe<Scalars['String']['output']>;
  type: Scalars['AiMessageType']['output'];
};

export type AppRating = {
  createdDatetime: Scalars['DateTime']['output'];
  feedback: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  learningPath: LearningPath;
  person: Person;
  rating: Maybe<Scalars['Int']['output']>;
};

export type AssociateAccountData = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  publicId: Scalars['String']['input'];
};

export type BuilderPathSave = {
  builderPath: Maybe<PublicBuilderPath>;
  error: Maybe<Scalars['String']['output']>;
};

export type BuilderPathSaveData = {
  email: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['Language']['input'];
  name: Scalars['String']['input'];
  note: InputMaybe<Scalars['String']['input']>;
  organisation: InputMaybe<Scalars['String']['input']>;
  showLength: Scalars['Boolean']['input'];
  showMiles: Scalars['Boolean']['input'];
  showPrice: Scalars['Boolean']['input'];
  showThemes: Scalars['Boolean']['input'];
  subject: InputMaybe<Scalars['String']['input']>;
  tasks: Array<Scalars['ID']['input']>;
};

export type CheckboxAnswer = {
  checked: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
};

export type CheckboxOption = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
};

export type CollectFeedback = {
  anonymous: Scalars['Boolean']['output'];
  collectFeedbackAnswerSets: Array<CollectFeedbackAnswerSet>;
  collectFeedbackQuestions: Array<CollectFeedbackQuestion>;
  created: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  heading: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['Language']['output'];
  open: Scalars['Boolean']['output'];
  publicId: Scalars['String']['output'];
  sendNotification: Scalars['Boolean']['output'];
  submittedTask: SubmittedTask;
};

export type CollectFeedbackAnswer = {
  collectFeedbackAnswerSet: CollectFeedbackAnswerSet;
  id: Scalars['ID']['output'];
  leftLabel: Maybe<Scalars['String']['output']>;
  leftTranslation: Maybe<Scalars['String']['output']>;
  likertAnswer: Maybe<Scalars['Int']['output']>;
  nr: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  rightLabel: Maybe<Scalars['String']['output']>;
  rightTranslation: Maybe<Scalars['String']['output']>;
  textAnswer: Maybe<Scalars['String']['output']>;
  translation: Maybe<Scalars['String']['output']>;
  type: Scalars['CollectFeedbackQuestionType']['output'];
};

export type CollectFeedbackAnswerSet = {
  collectFeedback: CollectFeedback;
  collectFeedbackAnswers: Array<CollectFeedbackAnswer>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  submitted: Scalars['DateTime']['output'];
};

export type CollectFeedbackQuestion = {
  collectFeedback: Maybe<LcCollectFeedback>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leftLabel: Maybe<Scalars['String']['output']>;
  leftTranslation: Maybe<Scalars['String']['output']>;
  nr: Scalars['Int']['output'];
  rightLabel: Maybe<Scalars['String']['output']>;
  rightTranslation: Maybe<Scalars['String']['output']>;
  translation: Maybe<Scalars['String']['output']>;
  type: Scalars['CollectFeedbackQuestionType']['output'];
};

export type ColorSchema = {
  background: Scalars['String']['output'];
  border: Scalars['String']['output'];
  button: Scalars['String']['output'];
  buttonDisabled: Scalars['String']['output'];
  calendarCurrentDay: Scalars['String']['output'];
  calendarDeadline: Scalars['String']['output'];
  calendarEvent: Scalars['String']['output'];
  calendarNotification: Scalars['String']['output'];
  calendarPublish: Scalars['String']['output'];
  calendarStartDate: Scalars['String']['output'];
  calendarUnlock: Scalars['String']['output'];
  completionsFinished: Scalars['String']['output'];
  completionsNotFinished: Scalars['String']['output'];
  completionsOverdue: Scalars['String']['output'];
  error: Scalars['String']['output'];
  header: Scalars['String']['output'];
  heart: Scalars['String']['output'];
  icon1: Scalars['String']['output'];
  icon2: Scalars['String']['output'];
  icon3: Scalars['String']['output'];
  icon4: Scalars['String']['output'];
  icon5: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  likert: Scalars['String']['output'];
  link: Scalars['String']['output'];
  navActive: Scalars['String']['output'];
  organisation: Maybe<Organisation>;
  performance: Scalars['String']['output'];
  performanceBackground: Scalars['String']['output'];
  pipBackground: Scalars['String']['output'];
  pipButton: Scalars['String']['output'];
  pipButtonDisabled: Scalars['String']['output'];
  pipFinished: Scalars['String']['output'];
  pipNav: Scalars['String']['output'];
  pollSelected: Scalars['String']['output'];
  progress: Scalars['String']['output'];
  quizCorrect: Scalars['String']['output'];
  quizIncorrect: Scalars['String']['output'];
  quizOption: Scalars['String']['output'];
  quizSelected: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  selectInImage: Scalars['String']['output'];
  selectInImageCorrect: Scalars['String']['output'];
  selectInImageIncorrect: Scalars['String']['output'];
  statusGreen: Scalars['String']['output'];
  statusRed: Scalars['String']['output'];
  statusYellow: Scalars['String']['output'];
  strategyStar: Scalars['String']['output'];
  success: Scalars['String']['output'];
  taskActive: Scalars['String']['output'];
  taskApprove: Scalars['String']['output'];
  taskDeadline: Scalars['String']['output'];
  taskFinished: Scalars['String']['output'];
  taskLocked: Scalars['String']['output'];
  taskQuestionNumber: Scalars['String']['output'];
  taskRedo: Scalars['String']['output'];
  taskUnlocked: Scalars['String']['output'];
  theme1: Scalars['String']['output'];
  theme2: Scalars['String']['output'];
  theme3: Scalars['String']['output'];
  theme4: Scalars['String']['output'];
  theme5: Scalars['String']['output'];
  unread: Scalars['String']['output'];
  warning: Scalars['String']['output'];
};

export type CompletedTask = {
  deadline: Maybe<Scalars['String']['output']>;
  finishColor: Scalars['String']['output'];
  submittedFeedbackTask: Maybe<SubmittedFeedbackTask>;
  submittedTask: Maybe<SubmittedTask>;
};

export type CreateAccountData = {
  agreedToTerms: Scalars['Boolean']['input'];
  avatar: Scalars['String']['input'];
  birthYear: InputMaybe<Scalars['Int']['input']>;
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emailNotifications: Scalars['Boolean']['input'];
  firstName: Scalars['String']['input'];
  gender: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  profilePicture: InputMaybe<Scalars['String']['input']>;
  publicId: Scalars['String']['input'];
  tel: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
};

export type Event = {
  description: Maybe<Scalars['String']['output']>;
  eventEnd: Maybe<Scalars['DateTime']['output']>;
  eventStart: Maybe<Scalars['DateTime']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  inspiration: Maybe<Media>;
  learningPathItem: Maybe<LearningPathItem>;
  media: Array<Media>;
  name: Scalars['String']['output'];
  objectives: Maybe<Scalars['String']['output']>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  remindLearningCoach: Scalars['Boolean']['output'];
};

export type FeedbackRequestSubmit = {
  error: Maybe<Scalars['String']['output']>;
  feedbackRequest: Maybe<PublicFeedbackRequest>;
};

export type FeedbackTask = {
  availableToFeedback: Array<SubmittedTask>;
  callToActionDay: Scalars['Int']['output'];
  deadlineDay: Maybe<Scalars['Int']['output']>;
  fixed: Scalars['Boolean']['output'];
  fixedCallToAction: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  learningPathItem: LearningPathItem;
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Maybe<Array<Maybe<LcNotification>>>;
  publishStatus: Scalars['PublishStatus']['output'];
  submittedFeedbackTasks: Array<SubmittedFeedbackTask>;
  task: Maybe<Task>;
};


export type FeedbackTaskAvailableToFeedbackArgs = {
  person: Scalars['String']['input'];
};

export type ImageSelectionAnswer = {
  answer: Maybe<Scalars['String']['output']>;
  answerType: Scalars['ImageSelectionAnswerType']['output'];
  clickX: Scalars['Float']['output'];
  clickY: Scalars['Float']['output'];
  explanation: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
  taskAnswer: TaskAnswer;
};

export type ImageSelectionArea = {
  bottomRightX: Scalars['Float']['output'];
  bottomRightY: Scalars['Float']['output'];
  explanation: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
  taskQuestion: TaskQuestion;
  topLeftX: Scalars['Float']['output'];
  topLeftY: Scalars['Float']['output'];
};

export type ImageSelectionScore = {
  earnedScore: Scalars['Int']['output'];
  possibleScore: Scalars['Int']['output'];
};

export type ImpactLikertAnswer = {
  id: Scalars['ID']['output'];
  impactTrackerAnswerSet: ImpactTrackerAnswerSet;
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ImpactLikertStatement = {
  id: Scalars['ID']['output'];
  impactTracker: Maybe<LcImpactTracker>;
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
};

export type ImpactTracker = {
  creator: Maybe<Person>;
  id: Scalars['ID']['output'];
  impactLikertStatements: Array<ImpactLikertStatement>;
  impactTrackerAnswerSets: Array<ImpactTrackerAnswerSet>;
  locale: Scalars['Language']['output'];
  name: Scalars['String']['output'];
};

export type ImpactTrackerAnswerSet = {
  id: Scalars['ID']['output'];
  impactLikertAnswers: Array<ImpactLikertAnswer>;
  impactTracker: Maybe<ImpactTracker>;
  taskAnswer: TaskAnswer;
};

export type Inspiration = {
  content: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  likeCount: Scalars['Int']['output'];
  readCount: Scalars['Int']['output'];
};

export type LcAiNewsletter = {
  aiThreadItems: Array<LcAiThreadItem>;
  content: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  learningPath: LcLearningPath;
  personality: Scalars['String']['output'];
  previousNewsletter: Maybe<LcAiNewsletter>;
  recipients: Array<Maybe<Scalars['String']['output']>>;
  startDate: Scalars['String']['output'];
  subject: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
};

export type LcAiThreadItem = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: Maybe<Scalars['AiMessageRoleType']['output']>;
  type: Scalars['AiMessageType']['output'];
};

export type LcAppRating = {
  createdDatetime: Scalars['DateTime']['output'];
  feedback: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person: LcPerson;
  rating: Maybe<Scalars['Int']['output']>;
};

export type LcCheckboxAnswer = {
  checked: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
};

export type LcCheckboxOption = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
};

export type LcCollectFeedback = {
  anonymous: Scalars['Boolean']['output'];
  collectFeedbackAnswerSets: Array<LcCollectFeedbackAnswerSet>;
  created: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  heading: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  submittedTask: LcSubmittedTask;
};

export type LcCollectFeedbackAnswer = {
  collectFeedbackAnswerSet: LcCollectFeedbackAnswerSet;
  id: Scalars['ID']['output'];
  leftLabel: Maybe<Scalars['String']['output']>;
  leftTranslation: Maybe<Scalars['String']['output']>;
  likertAnswer: Maybe<Scalars['Int']['output']>;
  nr: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  rightLabel: Maybe<Scalars['String']['output']>;
  rightTranslation: Maybe<Scalars['String']['output']>;
  textAnswer: Maybe<Scalars['String']['output']>;
  translation: Maybe<Scalars['String']['output']>;
  type: Scalars['CollectFeedbackQuestionType']['output'];
};

export type LcCollectFeedbackAnswerSet = {
  collectFeedback: LcCollectFeedback;
  collectFeedbackAnswers: Array<LcCollectFeedbackAnswer>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  submitted: Scalars['DateTime']['output'];
};

export type LcCompletions = {
  completions: Array<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  ids: Array<Scalars['Int']['output']>;
  names: Array<Scalars['String']['output']>;
  taskIds: Array<Array<Scalars['Int']['output']>>;
  tasks: Array<Scalars['String']['output']>;
};

export type LcEvent = {
  description: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  eventEnd: Maybe<Scalars['DateTime']['output']>;
  eventStart: Maybe<Scalars['DateTime']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  inspiration: Maybe<LcMedia>;
  learningPathItem: Maybe<LcLearningPathItem>;
  media: Array<LcMedia>;
  name: Scalars['String']['output'];
  objectives: Maybe<Scalars['String']['output']>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  remindLearningCoach: Scalars['Boolean']['output'];
};

export type LcFeedbackTask = {
  callToActionDay: Scalars['Int']['output'];
  deadlineDay: Maybe<Scalars['Int']['output']>;
  editable: Scalars['Boolean']['output'];
  fixed: Scalars['Boolean']['output'];
  fixedCallToAction: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  learningPathItem: LcLearningPathItem;
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<LcNotification>;
  publishStatus: Scalars['PublishStatus']['output'];
  submittedFeedbackTasks: Array<LcSubmittedFeedbackTask>;
  task: LcTask;
};

export type LcImageSelectionAnswer = {
  answer: Maybe<Scalars['String']['output']>;
  answerType: Scalars['ImageSelectionAnswerType']['output'];
  clickX: Scalars['Float']['output'];
  clickY: Scalars['Float']['output'];
  explanation: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
  taskAnswer: LcTaskAnswer;
};

export type LcImageSelectionArea = {
  bottomRightX: Scalars['Float']['output'];
  bottomRightY: Scalars['Float']['output'];
  explanation: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
  taskQuestion: LcTaskQuestion;
  topLeftX: Scalars['Float']['output'];
  topLeftY: Scalars['Float']['output'];
};

export type LcImageSelectionScore = {
  earnedScore: Scalars['Int']['output'];
  possibleScore: Scalars['Int']['output'];
};

export type LcImpactLikertAnswer = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type LcImpactLikertStatement = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
};

export type LcImpactTracker = {
  id: Scalars['ID']['output'];
  impactLikertStatements: Array<LcImpactLikertStatement>;
  locale: Scalars['Language']['output'];
  name: Scalars['String']['output'];
};

export type LcImpactTrackerAnswerSet = {
  id: Scalars['ID']['output'];
  impactLikertAnswers: Array<LcImpactLikertAnswer>;
};

export type LcInspiration = {
  content: Scalars['String']['output'];
  created: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  learningPath: LcLearningPath;
  likeCount: Scalars['Int']['output'];
  readCount: Scalars['Int']['output'];
};

export type LcLeaderboard = {
  id: Scalars['ID']['output'];
  learningPath: LcLearningPath;
  mode: Scalars['LeaderboardModeType']['output'];
  name: Scalars['String']['output'];
  rankings: Array<LcLeaderboardRanking>;
  specifiedFeedbackTasks: Array<LcFeedbackTask>;
  specifiedTasks: Array<LcTask>;
};

export type LcLeaderboardRanking = {
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  miles: Scalars['Int']['output'];
  pathMembershipId: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export type LcLearningPath = {
  additionalAiContext: Maybe<Scalars['String']['output']>;
  aiNewsletters: Array<LcAiNewsletter>;
  appRatingConfig: Scalars['AppRatingType']['output'];
  appRatings: Array<LcAppRating>;
  checkpoint: Scalars['Int']['output'];
  completions: LcCompletions;
  currentLearningCoach: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  endDate: Maybe<Scalars['String']['output']>;
  fixed: Scalars['Boolean']['output'];
  fixedStartDate: Maybe<Scalars['String']['output']>;
  goal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  info: Maybe<Scalars['String']['output']>;
  inspirations: Array<LcInspiration>;
  leaderboards: Array<LcLeaderboard>;
  learningCoach: LcPerson;
  learningPathItems: Array<LcLearningPathItem>;
  length: Scalars['Int']['output'];
  locale: Scalars['Language']['output'];
  name: Scalars['String']['output'];
  notifications: Array<LcNotification>;
  pathGroups: Array<LcPathGroup>;
  pathMemberships: Array<LcPathMembership>;
  pathname: Scalars['String']['output'];
  redCutoff: Scalars['Int']['output'];
  scoreboards: Array<LcScoreboard>;
  showInspirationDate: Scalars['Boolean']['output'];
  showRatingAfterTasks: Maybe<Scalars['Int']['output']>;
  startDate: Maybe<Scalars['String']['output']>;
  status: Scalars['PathStatus']['output'];
  yellowCutoff: Scalars['Int']['output'];
};

export type LcLearningPathItem = {
  callToActionDay: Maybe<Scalars['Int']['output']>;
  deadlineDay: Maybe<Scalars['Int']['output']>;
  event: Maybe<LcEvent>;
  feedbackTask: Maybe<LcFeedbackTask>;
  fixed: Maybe<Scalars['Boolean']['output']>;
  fixedCallToAction: Maybe<Scalars['Date']['output']>;
  icon: Maybe<Scalars['TaskIcon']['output']>;
  id: Scalars['ID']['output'];
  learningPath: LcLearningPath;
  lockedType: Maybe<Scalars['ItemLockedType']['output']>;
  miles: Maybe<Array<Scalars['Int']['output']>>;
  name: Maybe<Scalars['String']['output']>;
  pathInPath: Maybe<LcPathInPath>;
  publishDate: Maybe<Scalars['Date']['output']>;
  publishStatus: Maybe<Scalars['PublishStatus']['output']>;
  taskChoice: Maybe<LcTaskChoice>;
  tasks: Array<LcTask>;
  type: Scalars['LearningPathItemType']['output'];
};

export type LcMedia = {
  altName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['String']['output']>;
  mediaType: Scalars['MediaType']['output'];
  name: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type LcNotification = {
  content: Scalars['String']['output'];
  contentFormat: Scalars['ContentFormat']['output'];
  editable: Scalars['Boolean']['output'];
  feedbackTask: Maybe<LcFeedbackTask>;
  id: Scalars['ID']['output'];
  learningPath: Maybe<LcLearningPath>;
  sendDateOffset: Scalars['Int']['output'];
  sendLimit: Scalars['NotificationSendLimitType']['output'];
  subject: Scalars['String']['output'];
  task: Maybe<LcTask>;
  taskChoice: Maybe<LcTaskChoice>;
  type: Scalars['NotificationType']['output'];
};

export type LcOrganisation = {
  id: Scalars['ID']['output'];
  logo: Maybe<PublicFeedbackMedia>;
  name: Scalars['String']['output'];
};

export type LcPathGroup = {
  id: Scalars['ID']['output'];
  learningPath: LcLearningPath;
  members: Array<LcPathMembership>;
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
};

export type LcPathInPath = {
  description: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  learningPathItem: Maybe<LcLearningPathItem>;
  name: Scalars['String']['output'];
  objectives: Maybe<Scalars['String']['output']>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  remindLearningCoach: Scalars['Boolean']['output'];
  showGroup: Scalars['Boolean']['output'];
};

export type LcPathMembership = {
  endDate: Scalars['Date']['output'];
  extraDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  learningPath: LcLearningPath;
  miles: Maybe<Scalars['Int']['output']>;
  pathGroup: Maybe<LcPathGroup>;
  person: LcPerson;
  startDate: Scalars['Date']['output'];
  status: Scalars['PlayerStatus']['output'];
  taskGroupMemberships: Array<LcTaskGroupMembership>;
};

export type LcPerson = {
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  organisation: Maybe<LcOrganisation>;
  pathMemberships: Array<LcPathMembership>;
  profilePicSrc: Maybe<Scalars['String']['output']>;
  submittedFeedbackTasks: Array<LcSubmittedFeedbackTask>;
  submittedTasks: Array<LcSubmittedTask>;
  team: Maybe<LcTeam>;
};

export type LcPoll = {
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LcPollAnswer = {
  answers: Array<Maybe<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  question: Maybe<LcPollQuestion>;
};

export type LcPollAnswerSet = {
  answers: Array<LcPollAnswer>;
  id: Scalars['ID']['output'];
  pollAnswerCount: Scalars['Int']['output'];
};

export type LcPollOption = {
  answerCount: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
};

export type LcPollQuestion = {
  chartType: Scalars['PollChartType']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxAnswers: Scalars['Int']['output'];
  minAnswers: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  options: Array<LcPollOption>;
};

export type LcPulse = {
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  pulseAnswers: Array<LcPulseAnswer>;
  question1: Scalars['String']['output'];
  question2: Maybe<Scalars['String']['output']>;
};

export type LcPulseAnswer = {
  answer1: Scalars['String']['output'];
  answer2: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type LcPulseSuggestedQuestion = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['Language']['output'];
};

export type LcQuiz = {
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LcQuizAnswer = {
  answer: Scalars['String']['output'];
  answeredQuestion: Maybe<LcQuizQuestion>;
  id: Scalars['ID']['output'];
};

export type LcQuizAnswerSet = {
  answers: Array<LcQuizAnswer>;
  id: Scalars['ID']['output'];
  results: Array<Scalars['Int']['output']>;
};

export type LcQuizQuestion = {
  correctAnswer: Scalars['String']['output'];
  description: Scalars['String']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  levelNumber: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  quizOptions: Array<QuizOption>;
};

export type LcScaleScore = {
  earnedScore: Scalars['Int']['output'];
  possibleScore: Scalars['Int']['output'];
};

export type LcScoreboard = {
  id: Scalars['ID']['output'];
  learningPath: LcLearningPath;
  name: Scalars['String']['output'];
  scores: Array<LcScoreboardScore>;
  specifiedFeedbackTasks: Array<LcFeedbackTask>;
  specifiedTasks: Array<LcTask>;
};

export type LcScoreboardScore = {
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pathMembershipId: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type LcSubmittedFeedbackTask = {
  assignDatetime: Scalars['DateTime']['output'];
  feedbackTask: LcFeedbackTask;
  finishDatetime: Maybe<Scalars['DateTime']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  person: LcPerson;
  selectedSubmittedTaskVariant: LcSubmittedTaskVariant;
  status: Scalars['SubmittedFeedbackTaskStatus']['output'];
};

export type LcSubmittedTask = {
  collectFeedback: Maybe<LcCollectFeedback>;
  doInGroup: Scalars['DoInGroupType']['output'];
  feedbacker: Maybe<LcPerson>;
  finishDatetime: Scalars['DateTime']['output'];
  finishMessage: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  inspiration: Maybe<LcMedia>;
  kind: Scalars['String']['output'];
  learningPathItem: Maybe<LcLearningPathItem>;
  media: Array<LcMedia>;
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  objectives: Maybe<Scalars['String']['output']>;
  people: Array<LcPerson>;
  requireApproval: Scalars['Boolean']['output'];
  sendMessageForAnswer: Scalars['Boolean']['output'];
  shareAnswers: Scalars['ShareAnswersType']['output'];
  shareAnswersAnonymously: Scalars['Boolean']['output'];
  skipDescriptionPage: Scalars['Boolean']['output'];
  status: Scalars['SubmittedTaskStatus']['output'];
  submittedTaskVariant: Maybe<LcSubmittedTaskVariant>;
  thread: Array<LcTaskThreadItem>;
  timeEstimate: Maybe<Scalars['TimeEstimateType']['output']>;
};

export type LcSubmittedTaskVariant = {
  allowAccessCollectedFeedback: Scalars['Boolean']['output'];
  allowAddQuestions: Scalars['Boolean']['output'];
  allowTranslateCollectedFeedback: Scalars['Boolean']['output'];
  anonymousCollectedFeedback: Scalars['Boolean']['output'];
  collectFeedbackDescription: Maybe<Scalars['String']['output']>;
  collectFeedbackTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  eventEnd: Maybe<Scalars['DateTime']['output']>;
  eventStart: Maybe<Scalars['DateTime']['output']>;
  feedbackInstructions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pulse: Maybe<LcPulse>;
  pulseSuggestedQuestions: Array<LcPulseSuggestedQuestion>;
  selectingSubmittedFeedbackTask: Maybe<LcSubmittedFeedbackTask>;
  submittedTask: Maybe<LcSubmittedTask>;
  suggestedQuestions: Array<LcSuggestedQuestion>;
  taskAiAssistConfig: Maybe<LcTaskAiAssistConfig>;
  taskAiAssistThreads: Array<LcTaskAiAssistThread>;
  taskAiConfig: Maybe<LcTaskAiConfig>;
  taskAiThread: Maybe<LcTaskAiThread>;
  taskQuestions: Array<LcTaskQuestion>;
  teamScan: Maybe<LcTeamScan>;
  variantTitle: Maybe<Scalars['String']['output']>;
  variantType: Scalars['VariantType']['output'];
};

export type LcSuggestedQuestion = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leftLabel: Maybe<Scalars['String']['output']>;
  nr: Scalars['Int']['output'];
  rightLabel: Maybe<Scalars['String']['output']>;
  type: Scalars['SuggestedQuestionsType']['output'];
};

export type LcSurveyGizmoSurvey = {
  id: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type LcTask = {
  callToActionDay: Scalars['Int']['output'];
  currentLearningCoach: Scalars['Boolean']['output'];
  deadlineDay: Maybe<Scalars['Int']['output']>;
  doInGroup: Scalars['DoInGroupType']['output'];
  editable: Scalars['Boolean']['output'];
  feedbackTask: Maybe<LcFeedbackTask>;
  finishMessage: Maybe<Scalars['String']['output']>;
  fixed: Scalars['Boolean']['output'];
  fixedCallToAction: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  inspiration: Maybe<LcMedia>;
  learningCoach: Maybe<LcPerson>;
  learningPathItem: LcLearningPathItem;
  lockedType: Scalars['TaskLockedType']['output'];
  media: Array<LcMedia>;
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<LcNotification>;
  objectives: Maybe<Scalars['String']['output']>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  remindLearningCoach: Scalars['Boolean']['output'];
  requireApproval: Scalars['Boolean']['output'];
  sendMessageForAnswer: Scalars['Boolean']['output'];
  shareAnswers: Scalars['ShareAnswersType']['output'];
  shareAnswersAnonymously: Scalars['Boolean']['output'];
  skipDescriptionPage: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  submittedTasks: Array<LcSubmittedTask>;
  taskGroups: Array<LcTaskGroup>;
  taskVariants: Array<LcTaskVariant>;
  timeEstimate: Maybe<Scalars['TimeEstimateType']['output']>;
  type: Scalars['TaskType']['output'];
  unlockDay: Maybe<Scalars['Int']['output']>;
  unlockFixedDate: Maybe<Scalars['String']['output']>;
  unlockItem: Maybe<LcLearningPathItem>;
};

export type LcTaskAiAssistConfig = {
  additionalContext: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  personality: Scalars['String']['output'];
};

export type LcTaskAiAssistThread = {
  aiThreadItems: Array<LcAiThreadItem>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: LcPerson;
  personality: Scalars['String']['output'];
  submittedTaskVariant: Maybe<LcSubmittedTaskVariant>;
  taskVariant: Maybe<LcTaskVariant>;
  updated: Scalars['DateTime']['output'];
};

export type LcTaskAiConfig = {
  additionalContext: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  personality: Scalars['String']['output'];
  playerInstructions: Maybe<Scalars['String']['output']>;
};

export type LcTaskAiThread = {
  aiThreadItems: Array<LcAiThreadItem>;
  id: Scalars['ID']['output'];
  submittedTaskVariant: Maybe<LcSubmittedTaskVariant>;
};

export type LcTaskAnswer = {
  answerContent: Maybe<Scalars['String']['output']>;
  answerType: Scalars['AnswerType']['output'];
  checkboxAnswers: Array<LcCheckboxAnswer>;
  id: Scalars['ID']['output'];
  imageSelectionAnswers: Array<LcImageSelectionAnswer>;
  imageSelectionScore: Maybe<LcImageSelectionScore>;
  impactTrackerAnswerSet: Maybe<LcImpactTrackerAnswerSet>;
  part: Scalars['Int']['output'];
  pollAnswerSet: Maybe<LcPollAnswerSet>;
  questionContent: Maybe<Scalars['String']['output']>;
  quizAnswerSet: Maybe<LcQuizAnswerSet>;
  scaleMilesByScore: Scalars['Boolean']['output'];
  selectInImageMedia: Maybe<LcMedia>;
  showPollResults: Scalars['Boolean']['output'];
  taskAnswerFile: Maybe<LcTaskAnswerFile>;
  taskLikertAnswers: Array<LcTaskLikertAnswer>;
  taskThreadItem: LcTaskThreadItem;
};

export type LcTaskAnswerFile = {
  extractedContent: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['String']['output']>;
  logoSrc: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  src: Maybe<Scalars['String']['output']>;
  taskAnswer: Maybe<PublicFeedbackTaskAnswer>;
  taskAnswerId: Maybe<Scalars['Int']['output']>;
};

export type LcTaskChoice = {
  callToActionDay: Scalars['Int']['output'];
  deadlineDay: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  discriminant: Scalars['String']['output'];
  fixed: Scalars['Boolean']['output'];
  fixedCallToAction: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  learningPathItem: LcLearningPathItem;
  lockedType: Scalars['TaskLockedType']['output'];
  name: Scalars['String']['output'];
  notifications: Array<LcNotification>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  unlockDay: Maybe<Scalars['Int']['output']>;
  unlockFixedDate: Maybe<Scalars['String']['output']>;
  unlockItem: Maybe<LcLearningPathItem>;
};

export type LcTaskGroup = {
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  task: LcTask;
  taskGroupMemberships: Array<LcTaskGroupMembership>;
};

export type LcTaskGroupMembership = {
  id: Scalars['ID']['output'];
  pathMembership: LcPathMembership;
  taskGroup: LcTaskGroup;
};

export type LcTaskLikertAnswer = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type LcTaskLikertStatement = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
};

export type LcTaskQuestion = {
  answerType: Scalars['AnswerType']['output'];
  checkboxOptions: Array<LcCheckboxOption>;
  id: Scalars['ID']['output'];
  imageSelectionAreas: Array<LcImageSelectionArea>;
  impactTracker: Maybe<LcImpactTracker>;
  part: Scalars['Int']['output'];
  poll: Maybe<LcPoll>;
  questionContent: Maybe<Scalars['String']['output']>;
  quiz: Maybe<LcQuiz>;
  requireAllCheckmarks: Scalars['Boolean']['output'];
  scaleMilesByScore: Scalars['Boolean']['output'];
  selectInImageMedia: Maybe<LcMedia>;
  showPollResults: Scalars['Boolean']['output'];
  surveyGizmo: Maybe<LcSurveyGizmoSurvey>;
  surveyGizmoId: Maybe<Scalars['String']['output']>;
  taskLikertStatements: Array<LcTaskLikertStatement>;
};

export type LcTaskThreadItem = {
  content: Maybe<Scalars['String']['output']>;
  contentFormat: Maybe<Scalars['ContentFormat']['output']>;
  datetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: Maybe<LcPerson>;
  scaleScore: Maybe<LcScaleScore>;
  submittedTask: LcSubmittedTask;
  subtype: Maybe<Scalars['TaskThreadItemSubtype']['output']>;
  taskAnswers: Array<LcTaskAnswer>;
  taskVariant: Maybe<LcTaskVariant>;
  type: Scalars['TaskThreadItemType']['output'];
};

export type LcTaskVariant = {
  allowAccessCollectedFeedback: Scalars['Boolean']['output'];
  allowAddQuestions: Scalars['Boolean']['output'];
  allowTranslateCollectedFeedback: Scalars['Boolean']['output'];
  anonymousCollectedFeedback: Scalars['Boolean']['output'];
  collectFeedbackDescription: Maybe<Scalars['String']['output']>;
  collectFeedbackTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  eventEnd: Maybe<Scalars['DateTime']['output']>;
  eventStart: Maybe<Scalars['DateTime']['output']>;
  feedbackInstructions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
  pulseSuggestedQuestions: Array<LcPulseSuggestedQuestion>;
  suggestedQuestions: Array<LcSuggestedQuestion>;
  taskAiAssistConfig: Maybe<LcTaskAiAssistConfig>;
  taskAiConfig: Maybe<LcTaskAiConfig>;
  taskQuestions: Array<LcTaskQuestion>;
  variantTitle: Maybe<Scalars['String']['output']>;
  variantType: Scalars['VariantType']['output'];
};

export type LcTeam = {
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type LcTeamScan = {
  datetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: Maybe<Person>;
  progress: Array<Scalars['Int']['output']>;
  report: Maybe<LcTeamScanReport>;
  reportDatetime: Maybe<Scalars['String']['output']>;
  status: Scalars['TeamScanStatus']['output'];
  submittedTaskVariant: Maybe<LcTaskVariant>;
};

export type LcTeamScanReport = {
  membersWhoAnswered: Scalars['Int']['output'];
  sna: Maybe<LcTeamScanReportSnaData>;
  tlb: Maybe<LcTeamScanReportVariable>;
  tps: Maybe<LcTeamScanReportVariable>;
};

export type LcTeamScanReportSnaData = {
  centralisation: Scalars['Float']['output'];
  density: Scalars['Float']['output'];
  links: Array<LcTeamScanReportSnaLink>;
  nodes: Array<LcTeamScanReportSnaNode>;
  teamLeaderLeadership: Scalars['Float']['output'];
  teamMemberAverageLeadership: Scalars['Float']['output'];
};

export type LcTeamScanReportSnaLink = {
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type LcTeamScanReportSnaNode = {
  id: Scalars['String']['output'];
  incoming: Scalars['Float']['output'];
  teamLeader: Scalars['Boolean']['output'];
};

export type LcTeamScanReportVariable = {
  actionPoints: Array<Scalars['String']['output']>;
  mean: Scalars['Float']['output'];
  membersMeans: Array<Scalars['Float']['output']>;
  questionIds: Array<Scalars['String']['output']>;
  questionMeans: Array<Scalars['Float']['output']>;
  questionStds: Array<Scalars['Float']['output']>;
  std: Scalars['Float']['output'];
  strengths: Array<Scalars['String']['output']>;
  weaknesses: Array<Scalars['String']['output']>;
};

export type Leaderboard = {
  id: Scalars['ID']['output'];
  learningPath: LearningPath;
  mode: Scalars['LeaderboardModeType']['output'];
  name: Scalars['String']['output'];
  rankings: Array<LeaderboardRanking>;
  specifiedFeedbackTasks: Array<Maybe<FeedbackTask>>;
  specifiedTasks: Array<Task>;
};

export type LeaderboardRanking = {
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  miles: Scalars['Int']['output'];
  pathMembershipId: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export type LearningCoachNote = {
  content: Scalars['String']['output'];
  createdDatetime: Scalars['DateTime']['output'];
  creator: Person;
  id: Scalars['ID']['output'];
  learningPath: LearningPath;
  person: Person;
  taskThreadItem: Maybe<TaskThreadItem>;
};

export type LearningPath = {
  additionalAiContext: Maybe<Scalars['String']['output']>;
  aiNewsletters: Array<AiNewsletter>;
  appRatingConfig: Scalars['AppRatingType']['output'];
  appRatings: Array<AppRating>;
  checkpoint: Scalars['Int']['output'];
  closed: Scalars['Boolean']['output'];
  completedTasks: Array<CompletedTask>;
  completions: AdminCompletions;
  customTaskLearningPathItems: Array<Maybe<LearningPathItem>>;
  fixed: Scalars['Boolean']['output'];
  fixedStartDate: Maybe<Scalars['String']['output']>;
  goal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  info: Maybe<Scalars['String']['output']>;
  inspirations: Array<Inspiration>;
  leaderboards: Array<Leaderboard>;
  learningCoach: Person;
  learningCoachMayEdit: Scalars['Boolean']['output'];
  learningCoachNotes: Array<LearningCoachNote>;
  learningPathItems: Array<LearningPathItem>;
  length: Scalars['Int']['output'];
  locale: Scalars['Language']['output'];
  name: Scalars['String']['output'];
  notifications: Array<Notification>;
  numLearningPathActivityReports: Scalars['Int']['output'];
  numParticipants: Scalars['Int']['output'];
  pathGroups: Array<PathGroup>;
  pathMemberships: Array<PathMembership>;
  pathname: Scalars['String']['output'];
  redCutoff: Scalars['Int']['output'];
  remainingTasks: Array<RemainigTask>;
  scoreboards: Array<Scoreboard>;
  showInspirationDate: Scalars['Boolean']['output'];
  showParticipants: Scalars['Boolean']['output'];
  showRatingAfterTasks: Maybe<Scalars['Int']['output']>;
  status: Scalars['PathStatus']['output'];
  trackingName: Maybe<Scalars['String']['output']>;
  yellowCutoff: Scalars['Int']['output'];
};


export type LearningPathCompletedTasksArgs = {
  id: Scalars['ID']['input'];
};


export type LearningPathRemainingTasksArgs = {
  id: Scalars['ID']['input'];
};

export type LearningPathItem = {
  callToActionDay: Maybe<Scalars['Int']['output']>;
  deadlineDay: Maybe<Scalars['Int']['output']>;
  event: Maybe<Event>;
  feedbackTask: Maybe<FeedbackTask>;
  fixed: Scalars['Boolean']['output'];
  fixedCallToAction: Maybe<Scalars['Date']['output']>;
  icon: Maybe<Scalars['TaskIcon']['output']>;
  id: Scalars['ID']['output'];
  learningPath: LearningPath;
  lockedType: Scalars['ItemLockedType']['output'];
  miles: Maybe<Array<Scalars['Int']['output']>>;
  name: Scalars['String']['output'];
  pathInPath: Maybe<PathInPath>;
  publishDate: Maybe<Scalars['Date']['output']>;
  publishStatus: Maybe<Scalars['PublishStatus']['output']>;
  submittedTasks: Array<SubmittedTask>;
  taskChoice: Maybe<TaskChoice>;
  tasks: Array<Task>;
  type: Scalars['LearningPathItemType']['output'];
};

export type Login = {
  error: Maybe<Scalars['String']['output']>;
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type LoginData = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

export type Media = {
  altName: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  creator: Maybe<Person>;
  externId: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkSrc: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  mediaType: Scalars['MediaType']['output'];
  name: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
  tags: Array<Tag>;
};

export type Mutations = {
  accountInvitationAssociateAccount: Maybe<AccountInvitationAssociateAccount>;
  accountInvitationCreateAccount: Maybe<AccountInvitationCreateAccount>;
  builderPathSave: Maybe<BuilderPathSave>;
  feedbackRequestSubmit: Maybe<FeedbackRequestSubmit>;
  login: Maybe<Login>;
  pollSubmitAnswers: Maybe<PublicPollSubmitAnswers>;
  pulseSubmit: Maybe<PublicPulseSubmit>;
  quizSubmitAnswers: Maybe<PublicQuizSubmitAnswers>;
  resetTokenSendPassword: Maybe<ResetSendPassword>;
  resetTokenSendToken: Maybe<ResetSendToken>;
  reusableAccountInvitationAssociateAccount: Maybe<ReusableAccountInvitationAssociateAccount>;
  reusableAccountInvitationCreateAccount: Maybe<ReusableAccountInvitationCreateAccount>;
};


export type MutationsAccountInvitationAssociateAccountArgs = {
  data: AssociateAccountData;
};


export type MutationsAccountInvitationCreateAccountArgs = {
  data: CreateAccountData;
};


export type MutationsBuilderPathSaveArgs = {
  data: BuilderPathSaveData;
};


export type MutationsFeedbackRequestSubmitArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  feedback: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationsLoginArgs = {
  data: LoginData;
};


export type MutationsPollSubmitAnswersArgs = {
  data: PollSubmitAnswersData;
};


export type MutationsPulseSubmitArgs = {
  answer1: Scalars['String']['input'];
  answer2: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsQuizSubmitAnswersArgs = {
  data: QuizSubmitAnswersData;
};


export type MutationsResetTokenSendPasswordArgs = {
  token: Scalars['String']['input'];
};


export type MutationsResetTokenSendTokenArgs = {
  email: Scalars['String']['input'];
};


export type MutationsReusableAccountInvitationAssociateAccountArgs = {
  data: AssociateAccountData;
};


export type MutationsReusableAccountInvitationCreateAccountArgs = {
  data: CreateAccountData;
};

export type Notification = {
  content: Scalars['String']['output'];
  contentFormat: Scalars['ContentFormat']['output'];
  feedbackTask: Maybe<FeedbackTask>;
  id: Scalars['ID']['output'];
  learningPath: Maybe<LearningPath>;
  sendDateOffset: Scalars['Int']['output'];
  sendLimit: Scalars['NotificationSendLimitType']['output'];
  subject: Scalars['String']['output'];
  task: Maybe<Task>;
  taskChoice: Maybe<TaskChoice>;
  type: Scalars['NotificationType']['output'];
};

export type Organisation = {
  additionalAiContext: Maybe<Scalars['String']['output']>;
  colorSchema: Maybe<ColorSchema>;
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  logo: Maybe<Media>;
  name: Scalars['String']['output'];
  people: Array<Person>;
  teams: Array<Team>;
};

export type PathGroup = {
  id: Scalars['ID']['output'];
  learningPath: LearningPath;
  members: Array<PathMembership>;
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
};

export type PathInPath = {
  description: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  learningPathItem: LearningPathItem;
  name: Scalars['String']['output'];
  objectives: Maybe<Scalars['String']['output']>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  remindLearningCoach: Scalars['Boolean']['output'];
  showGroup: Scalars['Boolean']['output'];
};

export type PathMembership = {
  completedTasksCount: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  extraDays: Scalars['Int']['output'];
  floatingStartDate: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  learningCoachNotes: Array<LearningCoachNote>;
  learningPath: LearningPath;
  miles: Maybe<Scalars['Int']['output']>;
  pathGroup: Maybe<PathGroup>;
  person: Person;
  startDate: Scalars['String']['output'];
  status: Scalars['PlayerStatus']['output'];
  taskGroupMemberships: Array<TaskGroupMembership>;
  timeOfLatestTask: Maybe<Scalars['String']['output']>;
};

export type Person = {
  adminMenuShortcuts: Array<Maybe<Scalars['String']['output']>>;
  appRatings: Array<AppRating>;
  birthYear: Maybe<Scalars['Int']['output']>;
  eMailNotifications: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['Gender']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  learningCoachGroups: Array<LearningPath>;
  learningCoachNotes: Array<LearningCoachNote>;
  locked: Scalars['Boolean']['output'];
  miles: Scalars['Int']['output'];
  milesLast30: Scalars['Int']['output'];
  milesThisMonth: Scalars['Int']['output'];
  noteForManager: Maybe<Scalars['String']['output']>;
  noteForPlayer: Maybe<Scalars['String']['output']>;
  numTasks: Scalars['Int']['output'];
  numTasksLast30: Scalars['Int']['output'];
  organisation: Organisation;
  pathMemberships: Array<PathMembership>;
  profilePicSrc: Maybe<Scalars['String']['output']>;
  spentMiles: Scalars['Int']['output'];
  submittedFeedbackTasks: Array<SubmittedFeedbackTask>;
  submittedTasks: Array<SubmittedTask>;
  team: Maybe<Team>;
  tel: Maybe<Scalars['String']['output']>;
  timeOfLatestTask: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  unspentMiles: Scalars['Int']['output'];
  user: User;
};

export type Poll = {
  answerCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['Language']['output'];
  name: Scalars['String']['output'];
  numQuestions: Scalars['Int']['output'];
  pollAnswerSets: Array<PollAnswerSet>;
  public: Scalars['Boolean']['output'];
  qrCode: Scalars['String']['output'];
  qrUrl: Scalars['String']['output'];
  questions: Array<PollQuestion>;
  resultDescription: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PollAnswer = {
  answerSet: PollAnswerSet;
  answers: Array<Maybe<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  question: Maybe<PollQuestion>;
};

export type PollAnswerDatum = {
  answers: Array<Scalars['Int']['input']>;
  questionId: Scalars['ID']['input'];
};

export type PollAnswerSet = {
  answerDate: Scalars['DateTime']['output'];
  answers: Array<PollAnswer>;
  id: Scalars['ID']['output'];
  person: Maybe<Person>;
  poll: Poll;
  pollAnswerCount: Scalars['Int']['output'];
  taskAnswer: Maybe<TaskAnswer>;
};

export type PollOption = {
  answerCount: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  pollQuestion: PollQuestion;
};

export type PollQuestion = {
  answers: Array<PollAnswer>;
  chartType: Scalars['PollChartType']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxAnswers: Scalars['Int']['output'];
  minAnswers: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  options: Array<PollOption>;
  poll: Poll;
  pollAnswer: Maybe<PollAnswer>;
};

export type PollSubmitAnswersData = {
  answers: Array<PollAnswerDatum>;
  pollId: Scalars['ID']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
  variantId: InputMaybe<Scalars['ID']['input']>;
};

export type PublicAccountInvitation = {
  closed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  learningPath: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  standaloneAiChatbotName: Maybe<Scalars['String']['output']>;
  teamScan: Scalars['Boolean']['output'];
};

export type PublicBuilderPath = {
  builderTaskOnPaths: Array<PublicBuilderTaskOnPath>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['Language']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  showLength: Scalars['Boolean']['output'];
  showMiles: Scalars['Boolean']['output'];
  showPrice: Scalars['Boolean']['output'];
  showThemes: Scalars['Boolean']['output'];
};

export type PublicBuilderTask = {
  description: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  isGroupTask: Scalars['Boolean']['output'];
  isLecture: Scalars['Boolean']['output'];
  isMedia: Scalars['Boolean']['output'];
  isPeopleEvent: Scalars['Boolean']['output'];
  learningCoachFeedback: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
  locale: Scalars['Language']['output'];
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  shortDescription: Maybe<Scalars['String']['output']>;
  themes: Array<PublicTaskTheme>;
};

export type PublicBuilderTaskOnPath = {
  builderPath: PublicBuilderPath;
  builderTask: PublicBuilderTask;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type PublicBuilderTaskPage = {
  builderTasks: Array<PublicBuilderTask>;
  countTotal: Scalars['Int']['output'];
};

export type PublicCurrentPerson = {
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  user: PublicCurrentUser;
};

export type PublicCurrentUser = {
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['Language']['output'];
  role: PublicRole;
};

export type PublicFeedbackCheckboxAnswer = {
  checked: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PublicFeedbackImageSelectionAnswer = {
  answer: Maybe<Scalars['String']['output']>;
  answerType: Scalars['ImageSelectionAnswerType']['output'];
  clickX: Scalars['Float']['output'];
  clickY: Scalars['Float']['output'];
  explanation: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
};

export type PublicFeedbackImageSelectionScore = {
  earnedScore: Scalars['Int']['output'];
  possibleScore: Scalars['Int']['output'];
};

export type PublicFeedbackImpactLikertAnswer = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type PublicFeedbackImpactTrackerAnswerSet = {
  id: Scalars['ID']['output'];
  impactLikertAnswers: Array<PublicFeedbackImpactLikertAnswer>;
};

export type PublicFeedbackMedia = {
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['String']['output']>;
  mediaType: Scalars['MediaType']['output'];
  name: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type PublicFeedbackPerson = {
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  profilePicSrc: Maybe<Scalars['String']['output']>;
};

export type PublicFeedbackRequest = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  submittedTask: PublicFeedbackSubmittedTask;
};

export type PublicFeedbackSubmittedTask = {
  description: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  media: Array<PublicFeedbackMedia>;
  name: Scalars['String']['output'];
  person: PublicFeedbackPerson;
  thread: Array<PublicFeedbackTaskThreadItem>;
};

export type PublicFeedbackTaskAnswer = {
  answerContent: Maybe<Scalars['String']['output']>;
  answerType: Scalars['AnswerType']['output'];
  checkboxAnswers: Array<PublicFeedbackCheckboxAnswer>;
  id: Scalars['ID']['output'];
  imageSelectionAnswers: Array<PublicFeedbackImageSelectionAnswer>;
  imageSelectionScore: Maybe<PublicFeedbackImageSelectionScore>;
  impactTrackerAnswerSet: Maybe<PublicFeedbackImpactTrackerAnswerSet>;
  part: Scalars['Int']['output'];
  questionContent: Maybe<Scalars['String']['output']>;
  selectInImageMedia: Maybe<PublicFeedbackMedia>;
  taskAnswerFile: Maybe<PublicFeedbackTaskAnswerFile>;
  taskLikertAnswers: Array<PublicFeedbackTaskLikertAnswer>;
};

export type PublicFeedbackTaskAnswerFile = {
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['String']['output']>;
  logoSrc: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  src: Scalars['String']['output'];
};


export type PublicFeedbackTaskAnswerFileSrcArgs = {
  publicId: Scalars['ID']['input'];
};

export type PublicFeedbackTaskLikertAnswer = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type PublicFeedbackTaskThreadItem = {
  content: Maybe<Scalars['String']['output']>;
  contentFormat: Maybe<Scalars['ContentFormat']['output']>;
  id: Scalars['ID']['output'];
  person: Maybe<PublicFeedbackPerson>;
  subtype: Maybe<Scalars['String']['output']>;
  taskAnswers: Array<PublicFeedbackTaskAnswer>;
  type: Scalars['TaskThreadItemType']['output'];
};

export type PublicImpactTrackerReport = {
  createdDatetime: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  learningPath: ReportLearningPath;
  locale: Scalars['String']['output'];
  logoSrc: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type PublicLearningPathActivityReport = {
  createdDatetime: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  learningPath: ReportLearningPath;
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  people: Array<PublicReportPerson>;
  version: Scalars['Int']['output'];
};

export type PublicPoll = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  qrCode: Scalars['String']['output'];
  questions: Array<PublicPollQuestion>;
  resultDescription: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PublicPollAnswer = {
  answerSet: Maybe<PublicPollAnswerSet>;
  answers: Array<Maybe<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  question: PublicPollQuestion;
};

export type PublicPollAnswerSet = {
  answers: Array<PublicPollAnswer>;
  id: Scalars['ID']['output'];
  pollAnswerCount: Scalars['Int']['output'];
};

export type PublicPollOption = {
  answerCount: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  question: PublicPollQuestion;
};

export type PublicPollQuestion = {
  chartType: Scalars['PollChartType']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxAnswers: Scalars['Int']['output'];
  minAnswers: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  options: Array<PublicPollOption>;
  poll: PublicPoll;
};

export type PublicPollSubmitAnswers = {
  error: Maybe<Scalars['String']['output']>;
  pollAnswerSet: Maybe<PublicPollAnswerSet>;
  redirect: Maybe<Scalars['String']['output']>;
};

export type PublicPulse = {
  id: Scalars['ID']['output'];
  question1: Scalars['String']['output'];
  question2: Maybe<Scalars['String']['output']>;
};

export type PublicPulseSubmit = {
  error: Maybe<Scalars['String']['output']>;
};

export type PublicQuiz = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numLevels: Scalars['Int']['output'];
  numQuestions: Scalars['Int']['output'];
  questions: Array<PublicQuizQuestion>;
};

export type PublicQuizAnswerSet = {
  answers: Array<QuizAnswer>;
  id: Scalars['ID']['output'];
};

export type PublicQuizQuestion = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  levelNumber: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  quiz: Quiz;
  quizOptions: Array<QuizOption>;
};

export type PublicQuizSubmitAnswers = {
  error: Maybe<Scalars['String']['output']>;
  quizAnswerSet: Maybe<PublicQuizAnswerSet>;
  redirect: Maybe<Scalars['String']['output']>;
};

export type PublicReportPerson = {
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type PublicReusableAccountInvitation = {
  closed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  learningPath: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
};

export type PublicRole = {
  id: Scalars['ID']['output'];
  name: Scalars['RoleName']['output'];
};

export type PublicTaskTheme = {
  id: Scalars['ID']['output'];
  theme: Scalars['TaskThemeType']['output'];
  value: Scalars['Float']['output'];
};

export type Pulse = {
  createdDatetime: Scalars['DateTime']['output'];
  creator: Maybe<Person>;
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  locale: Scalars['Language']['output'];
  name: Maybe<Scalars['String']['output']>;
  pulseAnswers: Array<PulseAnswer>;
  question1: Scalars['String']['output'];
  question2: Maybe<Scalars['String']['output']>;
  submittedTaskVariant: Maybe<SubmittedTaskVariant>;
};

export type PulseAnswer = {
  answer1: Scalars['String']['output'];
  answer2: Maybe<Scalars['String']['output']>;
  createdDatetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pulse: Pulse;
};

export type PulseSuggestedQuestion = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['Language']['output'];
};

export type Query = {
  accountInvitation: Maybe<PublicAccountInvitation>;
  builderPath: Maybe<PublicBuilderPath>;
  builderPathList: Array<PublicBuilderPath>;
  builderTask: Maybe<PublicBuilderTask>;
  builderTaskPage: PublicBuilderTaskPage;
  currentBannerNotice: Maybe<Scalars['String']['output']>;
  currentPerson: Maybe<PublicCurrentPerson>;
  feedbackRequest: Maybe<PublicFeedbackRequest>;
  impactTrackerReport: Maybe<PublicImpactTrackerReport>;
  learningPathActivityReport: Maybe<PublicLearningPathActivityReport>;
  poll: Maybe<PublicPoll>;
  pulse: Maybe<PublicPulse>;
  quiz: Maybe<PublicQuiz>;
  reusableAccountInvitation: Maybe<PublicReusableAccountInvitation>;
};


export type QueryAccountInvitationArgs = {
  id: Scalars['String']['input'];
};


export type QueryBuilderPathArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBuilderPathListArgs = {
  locale: Scalars['Language']['input'];
};


export type QueryBuilderTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBuilderTaskPageArgs = {
  locale: Scalars['Language']['input'];
  page: Scalars['Int']['input'];
  sortBy: InputMaybe<Scalars['String']['input']>;
  sortDir: InputMaybe<Scalars['String']['input']>;
  taskType: InputMaybe<Scalars['String']['input']>;
  themes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFeedbackRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImpactTrackerReportArgs = {
  id: Scalars['ID']['input'];
  pwd: Scalars['String']['input'];
};


export type QueryLearningPathActivityReportArgs = {
  id: Scalars['ID']['input'];
  pwd: Scalars['String']['input'];
};


export type QueryPollArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPulseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuizArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReusableAccountInvitationArgs = {
  id: Scalars['String']['input'];
};

export type Quiz = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['Language']['output'];
  name: Scalars['String']['output'];
  numAnswers: Scalars['Int']['output'];
  numCompleteAnswers: Scalars['Int']['output'];
  numLevels: Scalars['Int']['output'];
  numQuestions: Scalars['Int']['output'];
  public: Scalars['Boolean']['output'];
  questions: Array<QuizQuestion>;
  quizAnswerSets: Array<QuizAnswerSet>;
  url: Scalars['String']['output'];
};

export type QuizAnswer = {
  answer: Scalars['String']['output'];
  answerSet: QuizAnswerSet;
  answeredQuestion: Maybe<QuizQuestion>;
  id: Scalars['ID']['output'];
  question: Maybe<QuizQuestion>;
};

export type QuizAnswerDatum = {
  letter: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
};

export type QuizAnswerSet = {
  answerDate: Scalars['DateTime']['output'];
  answers: Maybe<Array<Maybe<QuizAnswer>>>;
  complete: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  person: Maybe<Person>;
  quiz: Quiz;
  results: Array<Scalars['Int']['output']>;
  taskAnswer: Maybe<TaskAnswer>;
};

export type QuizOption = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  letter: Scalars['String']['output'];
  quizQuestion: QuizQuestion;
};

export type QuizQuestion = {
  answerDist: Array<Scalars['Int']['output']>;
  answers: Array<QuizAnswer>;
  correctAnswer: Scalars['String']['output'];
  correctPercent: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  levelNumber: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  quiz: Maybe<Quiz>;
  quizAnswer: Maybe<QuizAnswer>;
  quizOptions: Array<QuizOption>;
};

export type QuizSubmitAnswersData = {
  answerSetId: InputMaybe<Scalars['ID']['input']>;
  answers: Array<QuizAnswerDatum>;
  quizId: Scalars['ID']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
  variantId: InputMaybe<Scalars['ID']['input']>;
};

export type RemainigTask = {
  callToAction: Scalars['String']['output'];
  deadline: Maybe<Scalars['String']['output']>;
  feedbackTask: Maybe<FeedbackTask>;
  finishColor: Scalars['String']['output'];
  submittedFeedbackTask: Maybe<SubmittedFeedbackTask>;
  submittedTask: Maybe<SubmittedTask>;
  task: Maybe<Task>;
};

export type ReportLearningPath = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pathname: Scalars['String']['output'];
};

export type ResetSendPassword = {
  error: Maybe<Scalars['String']['output']>;
};

export type ResetSendToken = {
  error: Maybe<Scalars['String']['output']>;
};

export type ReusableAccountInvitationAssociateAccount = {
  error: Maybe<Scalars['String']['output']>;
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type ReusableAccountInvitationCreateAccount = {
  error: Maybe<Scalars['String']['output']>;
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type Role = {
  id: Scalars['ID']['output'];
  name: Scalars['RoleName']['output'];
};

export type ScaleScore = {
  earnedScore: Scalars['Int']['output'];
  possibleScore: Scalars['Int']['output'];
};

export type Scoreboard = {
  id: Scalars['ID']['output'];
  learningPath: LearningPath;
  name: Scalars['String']['output'];
  scores: Array<ScoreboardScore>;
  specifiedFeedbackTasks: Array<FeedbackTask>;
  specifiedTasks: Array<Task>;
};

export type ScoreboardScore = {
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pathMembershipId: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type StandaloneAiChatbot = {
  additionalContext: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  people: Array<Person>;
  personality: Scalars['String']['output'];
  standaloneAiThreads: Array<StandaloneAiThread>;
  updated: Scalars['DateTime']['output'];
};

export type StandaloneAiThread = {
  aiThreadItems: Maybe<Array<Maybe<AiThreadItem>>>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: Person;
  personality: Scalars['String']['output'];
  standaloneAiChatbot: StandaloneAiChatbot;
  updated: Scalars['DateTime']['output'];
};

export type SubmittedFeedbackTask = {
  assignDatetime: Scalars['DateTime']['output'];
  feedbackTask: FeedbackTask;
  finishDatetime: Maybe<Scalars['DateTime']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  person: Person;
  selectedSubmittedTaskVariant: SubmittedTaskVariant;
  status: Scalars['SubmittedFeedbackTaskStatus']['output'];
};

export type SubmittedTask = {
  collectFeedback: Maybe<CollectFeedback>;
  doInGroup: Scalars['DoInGroupType']['output'];
  feedbacker: Maybe<Person>;
  finishDatetime: Scalars['DateTime']['output'];
  finishMessage: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  inspiration: Maybe<Media>;
  kind: Scalars['String']['output'];
  learningPathItem: Maybe<LearningPathItem>;
  media: Array<Media>;
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  objectives: Maybe<Scalars['String']['output']>;
  people: Array<Person>;
  polldaddyQuizId: Maybe<Scalars['String']['output']>;
  requireApproval: Scalars['Boolean']['output'];
  sendMessageForAnswer: Scalars['Boolean']['output'];
  shareAnswers: Scalars['ShareAnswersType']['output'];
  shareAnswersAnonymously: Scalars['Boolean']['output'];
  skipDescriptionPage: Scalars['Boolean']['output'];
  status: Scalars['SubmittedTaskStatus']['output'];
  submittedTaskVariant: SubmittedTaskVariant;
  task: Maybe<Task>;
  thread: Array<TaskThreadItem>;
  timeEstimate: Maybe<Scalars['TimeEstimateType']['output']>;
};

export type SubmittedTaskVariant = {
  allowAccessCollectedFeedback: Scalars['Boolean']['output'];
  allowAddQuestions: Scalars['Boolean']['output'];
  allowTranslateCollectedFeedback: Scalars['Boolean']['output'];
  anonymousCollectedFeedback: Scalars['Boolean']['output'];
  collectFeedbackDescription: Maybe<Scalars['String']['output']>;
  collectFeedbackTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  eventEnd: Maybe<Scalars['DateTime']['output']>;
  eventStart: Maybe<Scalars['DateTime']['output']>;
  feedbackInstructions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pulse: Maybe<Pulse>;
  pulseSuggestedQuestions: Array<PulseSuggestedQuestion>;
  selectingSubmittedFeedbackTask: Maybe<SubmittedFeedbackTask>;
  submittedTask: SubmittedTask;
  suggestedQuestions: Array<SuggestedQuestion>;
  taskAiAssistConfig: Maybe<TaskAiAssistConfig>;
  taskAiAssistThreads: Array<TaskAiAssistThread>;
  taskAiConfig: Maybe<TaskAiConfig>;
  taskAiThread: Maybe<TaskAiThread>;
  taskQuestions: Array<TaskQuestion>;
  teamScan: Maybe<TeamScan>;
  variantTitle: Maybe<Scalars['String']['output']>;
  variantType: Scalars['VariantType']['output'];
};

export type SuggestedQuestion = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leftLabel: Maybe<Scalars['String']['output']>;
  nr: Scalars['Int']['output'];
  rightLabel: Maybe<Scalars['String']['output']>;
  type: Scalars['SuggestedQuestionsType']['output'];
};

export type SurveyGizmoSurvey = {
  id: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type Tag = {
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Task = {
  callToActionDay: Scalars['Int']['output'];
  deadlineDay: Maybe<Scalars['Int']['output']>;
  doInGroup: Scalars['DoInGroupType']['output'];
  feedbackTask: Maybe<FeedbackTask>;
  finishMessage: Maybe<Scalars['String']['output']>;
  fixed: Scalars['Boolean']['output'];
  fixedCallToAction: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  inspiration: Maybe<Media>;
  learningCoach: Maybe<Person>;
  learningCoachMayEdit: Scalars['Boolean']['output'];
  learningPathItem: LearningPathItem;
  lockedType: Scalars['TaskLockedType']['output'];
  media: Array<Media>;
  miles: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notifications: Array<Notification>;
  objectives: Maybe<Scalars['String']['output']>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  remindLearningCoach: Scalars['Boolean']['output'];
  requireApproval: Scalars['Boolean']['output'];
  sendMessageForAnswer: Scalars['Boolean']['output'];
  shareAnswers: Scalars['ShareAnswersType']['output'];
  shareAnswersAnonymously: Scalars['Boolean']['output'];
  skipDescriptionPage: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  submittedTasks: Array<SubmittedTask>;
  taskGroups: Array<TaskGroup>;
  taskVariants: Array<TaskVariant>;
  timeEstimate: Maybe<Scalars['TimeEstimateType']['output']>;
  type: Scalars['TaskType']['output'];
  unlockDay: Maybe<Scalars['Int']['output']>;
  unlockFixedDate: Maybe<Scalars['String']['output']>;
  unlockItem: Maybe<LearningPathItem>;
};

export type TaskAiAssistConfig = {
  additionalContext: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  personality: Scalars['String']['output'];
};

export type TaskAiAssistThread = {
  aiThreadItems: Maybe<Array<Maybe<AiThreadItem>>>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: Maybe<PublicCurrentPerson>;
  personality: Scalars['String']['output'];
  submittedTaskVariant: Maybe<SubmittedTaskVariant>;
  taskVariant: Maybe<TaskVariant>;
  updated: Scalars['DateTime']['output'];
};

export type TaskAiConfig = {
  additionalContext: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  personality: Scalars['String']['output'];
  playerInstructions: Maybe<Scalars['String']['output']>;
};

export type TaskAiThread = {
  aiThreadItems: Maybe<Array<Maybe<AiThreadItem>>>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: Person;
  personality: Scalars['String']['output'];
  submittedTaskVariant: SubmittedTaskVariant;
  updated: Scalars['DateTime']['output'];
};

export type TaskAnswer = {
  answerContent: Maybe<Scalars['String']['output']>;
  answerType: Scalars['AnswerType']['output'];
  checkboxAnswers: Array<CheckboxAnswer>;
  id: Scalars['ID']['output'];
  imageSelectionAnswers: Array<ImageSelectionAnswer>;
  imageSelectionScore: ImageSelectionScore;
  impactTrackerAnswerSet: Maybe<ImpactTrackerAnswerSet>;
  part: Scalars['Int']['output'];
  pollAnswerSet: Maybe<PollAnswerSet>;
  questionContent: Maybe<Scalars['String']['output']>;
  quizAnswerSet: Maybe<QuizAnswerSet>;
  scaleMilesByScore: Scalars['Boolean']['output'];
  selectInImageMedia: Maybe<Media>;
  showPollResults: Scalars['Boolean']['output'];
  surveyGizmoRespId: Maybe<Scalars['String']['output']>;
  taskAnswerFile: Maybe<TaskAnswerFile>;
  taskLikertAnswers: Array<TaskLikertAnswer>;
  taskThreadItem: TaskThreadItem;
};

export type TaskAnswerFile = {
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo: Maybe<Scalars['String']['output']>;
  logoSrc: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  src: Scalars['String']['output'];
};

export type TaskChoice = {
  callToActionDay: Scalars['Int']['output'];
  deadlineDay: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  discriminant: Scalars['String']['output'];
  fixed: Scalars['Boolean']['output'];
  fixedCallToAction: Maybe<Scalars['String']['output']>;
  icon: Scalars['TaskIcon']['output'];
  id: Scalars['ID']['output'];
  learningPathItem: LearningPathItem;
  lockedType: Scalars['TaskLockedType']['output'];
  name: Scalars['String']['output'];
  notifications: Array<Notification>;
  publishDate: Maybe<Scalars['String']['output']>;
  publishStatus: Scalars['PublishStatus']['output'];
  unlockDay: Maybe<Scalars['Int']['output']>;
  unlockFixedDate: Maybe<Scalars['String']['output']>;
  unlockItem: Maybe<LearningPathItem>;
};

export type TaskGroup = {
  accountInvitations: Array<AccountInvitation>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  task: Task;
  taskGroupMemberships: Array<TaskGroupMembership>;
};

export type TaskGroupMembership = {
  id: Scalars['ID']['output'];
  pathMembership: PathMembership;
  taskGroup: TaskGroup;
};

export type TaskLikertAnswer = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
  taskAnswer: Maybe<PublicFeedbackTaskAnswer>;
  value: Scalars['Int']['output'];
};

export type TaskLikertStatement = {
  id: Scalars['ID']['output'];
  leftLabel: Scalars['String']['output'];
  part: Scalars['Int']['output'];
  rightLabel: Scalars['String']['output'];
  statement: Scalars['String']['output'];
  taskQuestion: Maybe<LcTaskQuestion>;
};

export type TaskQuestion = {
  answerType: Scalars['AnswerType']['output'];
  checkboxOptions: Array<CheckboxOption>;
  id: Scalars['ID']['output'];
  imageSelectionAreas: Array<ImageSelectionArea>;
  impactTracker: Maybe<ImpactTracker>;
  part: Scalars['Int']['output'];
  poll: Maybe<Poll>;
  questionContent: Maybe<Scalars['String']['output']>;
  quiz: Maybe<Quiz>;
  requireAllCheckmarks: Scalars['Boolean']['output'];
  scaleMilesByScore: Scalars['Boolean']['output'];
  selectInImageMedia: Maybe<Media>;
  showPollResults: Scalars['Boolean']['output'];
  surveyGizmo: Maybe<SurveyGizmoSurvey>;
  surveyGizmoId: Maybe<Scalars['String']['output']>;
  taskLikertStatements: Array<TaskLikertStatement>;
};

export type TaskThreadItem = {
  content: Maybe<Scalars['String']['output']>;
  contentFormat: Maybe<Scalars['ContentFormat']['output']>;
  datetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  person: Maybe<Person>;
  scaleScore: Maybe<ScaleScore>;
  submittedTask: SubmittedTask;
  subtype: Maybe<Scalars['TaskThreadItemSubtype']['output']>;
  taskAnswers: Array<TaskAnswer>;
  type: Scalars['TaskThreadItemType']['output'];
};

export type TaskVariant = {
  allowAccessCollectedFeedback: Scalars['Boolean']['output'];
  allowAddQuestions: Scalars['Boolean']['output'];
  allowTranslateCollectedFeedback: Scalars['Boolean']['output'];
  anonymousCollectedFeedback: Scalars['Boolean']['output'];
  collectFeedbackDescription: Maybe<Scalars['String']['output']>;
  collectFeedbackTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  eventEnd: Maybe<Scalars['DateTime']['output']>;
  eventStart: Maybe<Scalars['DateTime']['output']>;
  feedbackInstructions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part: Scalars['Int']['output'];
  pulseSuggestedQuestions: Array<PulseSuggestedQuestion>;
  suggestedQuestions: Array<SuggestedQuestion>;
  taskAiAssistConfig: Maybe<TaskAiAssistConfig>;
  taskAiConfig: Maybe<TaskAiConfig>;
  taskQuestions: Array<TaskQuestion>;
  variantTitle: Maybe<Scalars['String']['output']>;
  variantType: Scalars['VariantType']['output'];
};

export type Team = {
  id: Scalars['ID']['output'];
  locked: Maybe<Scalars['Boolean']['output']>;
  members: Array<Person>;
  name: Maybe<Scalars['String']['output']>;
  organisation: Organisation;
};

export type TeamScan = {
  datetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  industry: Maybe<Scalars['String']['output']>;
  locale: Scalars['Language']['output'];
  organisationSize: Maybe<Scalars['String']['output']>;
  person: Maybe<Person>;
  progress: Maybe<Array<Scalars['Int']['output']>>;
  report: Maybe<AdminTeamScanReport>;
  reportDatetime: Maybe<Scalars['String']['output']>;
  status: Scalars['TeamScanStatus']['output'];
  submittedTaskVariant: Maybe<SubmittedTaskVariant>;
  teamScanSurveys: Maybe<Array<TeamScanSurvey>>;
  teamSizeLimit: Maybe<Scalars['Int']['output']>;
};

export type TeamScanSurvey = {
  datetime: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  link: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  teamLeader: Scalars['Boolean']['output'];
  teamScan: TeamScan;
  teamScanSurveyAnswers: Array<TeamScanSurvey>;
};

export type User = {
  agreedToTerms: Maybe<Scalars['Boolean']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  locale: Scalars['Language']['output'];
  person: Person;
  pulseRights: Scalars['Boolean']['output'];
  role: Role;
};

export type PollQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PollQueryQuery = { poll: { id: string, description: string, resultDescription: string | null, questions: Array<{ id: string, minAnswers: number, maxAnswers: number, number: number, content: string, options: Array<{ id: string, number: number, content: string }> }> } | null };

export type PollSubmitAnswersMutationMutationVariables = Exact<{
  data: PollSubmitAnswersData;
}>;


export type PollSubmitAnswersMutationMutation = { pollSubmitAnswers: { error: string | null, redirect: string | null, pollAnswerSet: { id: string, pollAnswerCount: number, answers: Array<{ id: string, answers: Array<number | null>, question: { id: string, number: number, content: string, chartType: import('../../shared/types.ts').PollChartType, options: Array<{ id: string, number: number, content: string, answerCount: number }> } }> } | null } | null };

export type CurrentPersonQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPersonQueryQuery = { currentPerson: { id: string, firstName: string, lastName: string, user: { email: string | null, role: { name: import('../../shared/types.ts').Role } } } | null };

export type LoginMutationMutationVariables = Exact<{
  data: LoginData;
}>;


export type LoginMutationMutation = { login: { error: string | null, redirectUrl: string | null } | null };

export type BuilderPathQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BuilderPathQueryQuery = { builderPath: { id: string, name: string, showThemes: boolean, showMiles: boolean, showLength: boolean, showPrice: boolean, builderTaskOnPaths: Array<{ id: string, builderTask: { id: string, icon: import('../../shared/types.ts').TaskIcon, miles: number, name: string, price: number, length: number, description: string | null, shortDescription: string | null, learningCoachFeedback: boolean, isGroupTask: boolean, isMedia: boolean, isPeopleEvent: boolean, isLecture: boolean, themes: Array<{ id: string, theme: import('../../shared/types.ts').TaskThemeType, value: number }> } }> } | null };

export type BuilderPathListQueryQueryVariables = Exact<{
  locale: Scalars['Language']['input'];
}>;


export type BuilderPathListQueryQuery = { builderPathList: Array<{ id: string, name: string, publicId: string, locale: import('../../shared/types.ts').Language, description: string | null, showThemes: boolean, showMiles: boolean, showLength: boolean, showPrice: boolean, builderTaskOnPaths: Array<{ id: string, builderTask: { id: string, icon: import('../../shared/types.ts').TaskIcon, name: string, shortDescription: string | null, miles: number, length: number, learningCoachFeedback: boolean, price: number, isGroupTask: boolean, isMedia: boolean, isPeopleEvent: boolean, isLecture: boolean, themes: Array<{ id: string, theme: import('../../shared/types.ts').TaskThemeType, value: number }> } }> }> };

export type BuilderPathSaveMutationMutationVariables = Exact<{
  data: BuilderPathSaveData;
}>;


export type BuilderPathSaveMutationMutation = { builderPathSave: { error: string | null, builderPath: { id: string } | null } | null };

export type BuilderPathListStartQueryQueryVariables = Exact<{
  locale: Scalars['Language']['input'];
}>;


export type BuilderPathListStartQueryQuery = { builderPathList: Array<{ id: string, name: string, publicId: string, locale: import('../../shared/types.ts').Language, description: string | null, showThemes: boolean, showMiles: boolean, showLength: boolean, showPrice: boolean, builderTaskOnPaths: Array<{ id: string, builderTask: { id: string, icon: import('../../shared/types.ts').TaskIcon, name: string, shortDescription: string | null, miles: number, length: number, learningCoachFeedback: boolean, price: number, isGroupTask: boolean, isMedia: boolean, isPeopleEvent: boolean, isLecture: boolean, themes: Array<{ id: string, theme: import('../../shared/types.ts').TaskThemeType, value: number }> } }> }> };

export type BuilderTaskPageQueryQueryVariables = Exact<{
  locale: Scalars['Language']['input'];
  page: Scalars['Int']['input'];
  sortBy: Scalars['String']['input'];
  sortDir: Scalars['String']['input'];
  themes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  taskType: Scalars['String']['input'];
}>;


export type BuilderTaskPageQueryQuery = { builderTaskPage: { countTotal: number, builderTasks: Array<{ id: string, icon: import('../../shared/types.ts').TaskIcon, miles: number, name: string, price: number, length: number, locale: import('../../shared/types.ts').Language, description: string | null, shortDescription: string | null, learningCoachFeedback: boolean, isGroupTask: boolean, isMedia: boolean, isPeopleEvent: boolean, isLecture: boolean, themes: Array<{ id: string, theme: import('../../shared/types.ts').TaskThemeType, value: number }> }> } };

export type CreateAccountInvitationsQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreateAccountInvitationsQueryQuery = { accountInvitation: { id: string, publicId: string, email: string, teamScan: boolean, learningPath: string | null, closed: boolean, standaloneAiChatbotName: string | null } | null, reusableAccountInvitation: { id: string, publicId: string, learningPath: string, closed: boolean } | null };

export type CreatePersonalAccountMutationMutationVariables = Exact<{
  data: CreateAccountData;
}>;


export type CreatePersonalAccountMutationMutation = { accountInvitationCreateAccount: { error: string | null, redirectUrl: string | null } | null };

export type CreateReusableAccountMutationMutationVariables = Exact<{
  data: CreateAccountData;
}>;


export type CreateReusableAccountMutationMutation = { reusableAccountInvitationCreateAccount: { error: string | null, redirectUrl: string | null } | null };

export type AssociatePersonalAccountMutationMutationVariables = Exact<{
  data: AssociateAccountData;
}>;


export type AssociatePersonalAccountMutationMutation = { accountInvitationAssociateAccount: { error: string | null, redirectUrl: string | null } | null };

export type AssociateReusableAccountMutationMutationVariables = Exact<{
  data: AssociateAccountData;
}>;


export type AssociateReusableAccountMutationMutation = { reusableAccountInvitationAssociateAccount: { error: string | null, redirectUrl: string | null } | null };

export type ImpactTrackerReportQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  pwd: Scalars['String']['input'];
}>;


export type ImpactTrackerReportQueryQuery = { impactTrackerReport: { id: string, version: number, data: string, createdDatetime: any, logoSrc: string | null, learningPath: { id: string, name: string, pathname: string } } | null };

export type LearningPathActivityReportQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  pwd: Scalars['String']['input'];
}>;


export type LearningPathActivityReportQueryQuery = { learningPathActivityReport: { id: string, version: number, name: string, data: string, createdDatetime: any, people: Array<{ id: string, firstName: string, lastName: string }>, learningPath: { id: string, name: string, pathname: string } } | null };

export type OutsideFeedbackSubmitMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  feedback: Scalars['String']['input'];
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type OutsideFeedbackSubmitMutationMutation = { feedbackRequestSubmit: { error: string | null, feedbackRequest: { id: string } | null } | null };

export type OutsideFeedbackQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutsideFeedbackQueryQuery = { feedbackRequest: { id: string, description: string, submittedTask: { id: string, icon: import('../../shared/types.ts').TaskIcon, name: string, description: string | null, media: Array<{ id: string, mediaType: any, name: string | null, logo: string | null, src: string }>, person: { id: string, firstName: string, lastName: string, profilePicSrc: string | null }, thread: Array<{ id: string, type: import('../../shared/types.ts').TaskThreadItemType, subtype: string | null, content: string | null, contentFormat: import('../../shared/types.ts').ContentFormat | null, taskAnswers: Array<{ id: string, answerType: import('../../shared/types.ts').AnswerType, questionContent: string | null, answerContent: string | null, checkboxAnswers: Array<{ id: string, content: string, checked: boolean }>, taskLikertAnswers: Array<{ id: string, statement: string, leftLabel: string, rightLabel: string, value: number }>, taskAnswerFile: { id: string, name: string, src: string, logoSrc: string | null } | null, impactTrackerAnswerSet: { id: string, impactLikertAnswers: Array<{ id: string, statement: string, leftLabel: string, rightLabel: string, value: number }> } | null, imageSelectionAnswers: Array<{ id: string, part: number, answerType: import('../../shared/types.ts').ImageSelectionAnswerType, clickX: number, clickY: number, explanation: string | null, answer: string | null }>, selectInImageMedia: { id: string, mediaType: any, src: string } | null, imageSelectionScore: { earnedScore: number, possibleScore: number } | null }>, person: { id: string, firstName: string, lastName: string, profilePicSrc: string | null } | null }> } } | null };

export type PulseQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PulseQueryQuery = { pulse: { id: string, question1: string, question2: string | null } | null };

export type PulseSubmitMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  answer1: Scalars['String']['input'];
  answer2: InputMaybe<Scalars['String']['input']>;
}>;


export type PulseSubmitMutationMutation = { pulseSubmit: { error: string | null } | null };

export type ResetTokenSendTokenMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetTokenSendTokenMutationMutation = { resetTokenSendToken: { error: string | null } | null };

export type ResetTokenSendPasswordMutationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ResetTokenSendPasswordMutationMutation = { resetTokenSendPassword: { error: string | null } | null };

export type QuizSubmitAnswersMutationMutationVariables = Exact<{
  data: QuizSubmitAnswersData;
}>;


export type QuizSubmitAnswersMutationMutation = { quizSubmitAnswers: { error: string | null, redirect: string | null, quizAnswerSet: { id: string, answers: Array<{ id: string, answer: string, answeredQuestion: { id: string, number: number, levelNumber: number, description: string, correctAnswer: string, explanation: string, quizOptions: Array<{ id: string, letter: string, content: string }> } | null }> } | null } | null };

export type QuizQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuizQueryQuery = { quiz: { id: string, description: string, numLevels: number, numQuestions: number, questions: Array<{ id: string, number: number, levelNumber: number, description: string, quizOptions: Array<{ id: string, letter: string, content: string }> }> } | null };


export const PollQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PollQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"resultDescription"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"maxAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PollQueryQuery, PollQueryQueryVariables>;
export const PollSubmitAnswersMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PollSubmitAnswersMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PollSubmitAnswersData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pollSubmitAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"redirect"}},{"kind":"Field","name":{"kind":"Name","value":"pollAnswerSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"chartType"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"answerCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pollAnswerCount"}}]}}]}}]}}]} as unknown as DocumentNode<PollSubmitAnswersMutationMutation, PollSubmitAnswersMutationMutationVariables>;
export const CurrentPersonQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentPersonQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentPersonQueryQuery, CurrentPersonQueryQueryVariables>;
export const LoginMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<LoginMutationMutation, LoginMutationMutationVariables>;
export const BuilderPathQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderPathQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builderPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showThemes"}},{"kind":"Field","name":{"kind":"Name","value":"showMiles"}},{"kind":"Field","name":{"kind":"Name","value":"showLength"}},{"kind":"Field","name":{"kind":"Name","value":"showPrice"}},{"kind":"Field","name":{"kind":"Name","value":"builderTaskOnPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"builderTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"miles"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"learningCoachFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTask"}},{"kind":"Field","name":{"kind":"Name","value":"isMedia"}},{"kind":"Field","name":{"kind":"Name","value":"isPeopleEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isLecture"}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BuilderPathQueryQuery, BuilderPathQueryQueryVariables>;
export const BuilderPathListQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderPathListQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builderPathList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"showThemes"}},{"kind":"Field","name":{"kind":"Name","value":"showMiles"}},{"kind":"Field","name":{"kind":"Name","value":"showLength"}},{"kind":"Field","name":{"kind":"Name","value":"showPrice"}},{"kind":"Field","name":{"kind":"Name","value":"builderTaskOnPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"builderTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"miles"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"learningCoachFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTask"}},{"kind":"Field","name":{"kind":"Name","value":"isMedia"}},{"kind":"Field","name":{"kind":"Name","value":"isPeopleEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isLecture"}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BuilderPathListQueryQuery, BuilderPathListQueryQueryVariables>;
export const BuilderPathSaveMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuilderPathSaveMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BuilderPathSaveData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builderPathSave"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"builderPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BuilderPathSaveMutationMutation, BuilderPathSaveMutationMutationVariables>;
export const BuilderPathListStartQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderPathListStartQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builderPathList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"showThemes"}},{"kind":"Field","name":{"kind":"Name","value":"showMiles"}},{"kind":"Field","name":{"kind":"Name","value":"showLength"}},{"kind":"Field","name":{"kind":"Name","value":"showPrice"}},{"kind":"Field","name":{"kind":"Name","value":"builderTaskOnPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"builderTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"miles"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"learningCoachFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTask"}},{"kind":"Field","name":{"kind":"Name","value":"isMedia"}},{"kind":"Field","name":{"kind":"Name","value":"isPeopleEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isLecture"}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BuilderPathListStartQueryQuery, BuilderPathListStartQueryQueryVariables>;
export const BuilderTaskPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuilderTaskPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"themes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builderTaskPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDir"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDir"}}},{"kind":"Argument","name":{"kind":"Name","value":"themes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"themes"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countTotal"}},{"kind":"Field","name":{"kind":"Name","value":"builderTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"miles"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"learningCoachFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupTask"}},{"kind":"Field","name":{"kind":"Name","value":"isMedia"}},{"kind":"Field","name":{"kind":"Name","value":"isPeopleEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isLecture"}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BuilderTaskPageQueryQuery, BuilderTaskPageQueryQueryVariables>;
export const CreateAccountInvitationsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateAccountInvitationsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"teamScan"}},{"kind":"Field","name":{"kind":"Name","value":"learningPath"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"standaloneAiChatbotName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reusableAccountInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicId"}},{"kind":"Field","name":{"kind":"Name","value":"learningPath"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}}]}}]}}]} as unknown as DocumentNode<CreateAccountInvitationsQueryQuery, CreateAccountInvitationsQueryQueryVariables>;
export const CreatePersonalAccountMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePersonalAccountMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccountData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountInvitationCreateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<CreatePersonalAccountMutationMutation, CreatePersonalAccountMutationMutationVariables>;
export const CreateReusableAccountMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReusableAccountMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccountData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reusableAccountInvitationCreateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<CreateReusableAccountMutationMutation, CreateReusableAccountMutationMutationVariables>;
export const AssociatePersonalAccountMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssociatePersonalAccountMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssociateAccountData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountInvitationAssociateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<AssociatePersonalAccountMutationMutation, AssociatePersonalAccountMutationMutationVariables>;
export const AssociateReusableAccountMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssociateReusableAccountMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssociateAccountData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reusableAccountInvitationAssociateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]} as unknown as DocumentNode<AssociateReusableAccountMutationMutation, AssociateReusableAccountMutationMutationVariables>;
export const ImpactTrackerReportQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImpactTrackerReportQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pwd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impactTrackerReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"pwd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pwd"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"logoSrc"}},{"kind":"Field","name":{"kind":"Name","value":"learningPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pathname"}}]}}]}}]}}]} as unknown as DocumentNode<ImpactTrackerReportQueryQuery, ImpactTrackerReportQueryQueryVariables>;
export const LearningPathActivityReportQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LearningPathActivityReportQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pwd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learningPathActivityReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"pwd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pwd"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"people"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"learningPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pathname"}}]}}]}}]}}]} as unknown as DocumentNode<LearningPathActivityReportQueryQuery, LearningPathActivityReportQueryQueryVariables>;
export const OutsideFeedbackSubmitMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OutsideFeedbackSubmitMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedback"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedbackRequestSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"feedback"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedback"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"feedbackRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OutsideFeedbackSubmitMutationMutation, OutsideFeedbackSubmitMutationMutationVariables>;
export const OutsideFeedbackQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OutsideFeedbackQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedbackRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"submittedTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicSrc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentFormat"}},{"kind":"Field","name":{"kind":"Name","value":"taskAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerType"}},{"kind":"Field","name":{"kind":"Name","value":"questionContent"}},{"kind":"Field","name":{"kind":"Name","value":"answerContent"}},{"kind":"Field","name":{"kind":"Name","value":"checkboxAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"checked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskLikertAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statement"}},{"kind":"Field","name":{"kind":"Name","value":"leftLabel"}},{"kind":"Field","name":{"kind":"Name","value":"rightLabel"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskAnswerFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"src"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"publicId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]},{"kind":"Field","name":{"kind":"Name","value":"logoSrc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"impactTrackerAnswerSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"impactLikertAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statement"}},{"kind":"Field","name":{"kind":"Name","value":"leftLabel"}},{"kind":"Field","name":{"kind":"Name","value":"rightLabel"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageSelectionAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"part"}},{"kind":"Field","name":{"kind":"Name","value":"answerType"}},{"kind":"Field","name":{"kind":"Name","value":"clickX"}},{"kind":"Field","name":{"kind":"Name","value":"clickY"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectInImageMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","name":{"kind":"Name","value":"src"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageSelectionScore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earnedScore"}},{"kind":"Field","name":{"kind":"Name","value":"possibleScore"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicSrc"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OutsideFeedbackQueryQuery, OutsideFeedbackQueryQueryVariables>;
export const PulseQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PulseQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question1"}},{"kind":"Field","name":{"kind":"Name","value":"question2"}}]}}]}}]} as unknown as DocumentNode<PulseQueryQuery, PulseQueryQueryVariables>;
export const PulseSubmitMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PulseSubmitMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answer1"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answer2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"answer1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answer1"}}},{"kind":"Argument","name":{"kind":"Name","value":"answer2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answer2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<PulseSubmitMutationMutation, PulseSubmitMutationMutationVariables>;
export const ResetTokenSendTokenMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetTokenSendTokenMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetTokenSendToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ResetTokenSendTokenMutationMutation, ResetTokenSendTokenMutationMutationVariables>;
export const ResetTokenSendPasswordMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetTokenSendPasswordMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetTokenSendPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ResetTokenSendPasswordMutationMutation, ResetTokenSendPasswordMutationMutationVariables>;
export const QuizSubmitAnswersMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QuizSubmitAnswersMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizSubmitAnswersData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quizSubmitAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"redirect"}},{"kind":"Field","name":{"kind":"Name","value":"quizAnswerSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"answeredQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"levelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"correctAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"quizOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"letter"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<QuizSubmitAnswersMutationMutation, QuizSubmitAnswersMutationMutationVariables>;
export const QuizQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuizQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"numLevels"}},{"kind":"Field","name":{"kind":"Name","value":"numQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"levelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quizOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"letter"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QuizQueryQuery, QuizQueryQueryVariables>;